import { styled } from "@mui/system";
import { withTheme } from "@emotion/react";
import { AppBar } from "@mui/material";

export const StyledAppBar = styled(withTheme(AppBar))((props) => ({
    backgroundColor: props.theme.palette.ga.ga50,
}));
